var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4027 1.98223e-06C12.9046 0.0102872 12.4614 0.322178 12.277 0.659925L10.5232 3.98516H4.18838C1.88971 3.98516 0 5.78317 0 7.97029V25.5049C0 27.692 1.88971 29.49 4.18838 29.49H32.6693C34.968 29.49 36.8577 27.692 36.8577 25.5049V7.97029C36.8577 5.78317 34.968 3.98516 32.6693 3.98516H26.3345L24.5807 0.659925C24.3724 0.265191 23.9189 -0.000837742 23.4547 1.98223e-06H13.4027ZM14.188 2.39122H22.6695L24.4233 5.71646C24.6313 6.11119 25.0848 6.37722 25.549 6.37638H32.6692C33.619 6.37638 34.3444 7.06661 34.3444 7.97029V25.5049C34.3444 26.4086 33.619 27.0988 32.6692 27.0988H4.18823C3.23844 27.0988 2.51303 26.4086 2.51303 25.5049V7.97029C2.51303 7.06659 3.23845 6.37638 4.18823 6.37638H11.3084C11.7726 6.37722 12.2261 6.11119 12.4341 5.71646L14.1879 2.39122H14.188ZM18.4287 8.36892C13.5859 8.36892 9.63311 12.13 9.63311 16.7377C9.63311 21.3454 13.586 25.1065 18.4287 25.1065C23.2714 25.1065 27.2243 21.3454 27.2243 16.7377C27.2243 12.13 23.2714 8.36892 18.4287 8.36892ZM18.4287 10.7601C21.9133 10.7601 24.7113 13.4223 24.7113 16.7378C24.7113 20.0533 21.9133 22.7155 18.4287 22.7155C14.9441 22.7155 12.1461 20.0533 12.1461 16.7378C12.1461 13.4223 14.9441 10.7601 18.4287 10.7601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.c3ab885fcd2d3ff4531bad11872236f6.svg";
export { ForwardRef as ReactComponent };